import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Ticket } from "lucide-react";
import { api } from "../../lib/api";
import { FadeUp, MaskLines, Eyebrow } from "../site/Motion";
import { WhatsAppIcon } from "../site/Icons";

const WD = ["lunes", "martes", "miércoles", "jueves", "viernes", "sábados", "domingos"];
const day = (s) => new Date(`${s}T12:00`).toLocaleDateString("es-AR", { day: "numeric", month: "short" }).replace(".", "");
export const when = (p) => (p.date_from === p.date_to ? `Viajando el ${day(p.date_from)}` : `Del ${day(p.date_from)} al ${day(p.date_to)}`);
export const only = (p) => (p.weekdays?.length ? `Solo ${p.weekdays.map((i) => WD[i]).join(", ").replace(/, ([^,]*)$/, " y $1")}` : "Todos los días con salida");
const todayAR = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Argentina/Buenos_Aires" });
const daysLeft = (end) => Math.round((new Date(`${end}T12:00`) - new Date(`${todayAR()}T12:00`)) / 86400000);
const countdown = (n) => (n <= 0 ? "¡Termina hoy!" : n === 1 ? "Termina mañana" : `Termina en ${n} días`);
const link = (p) => `/pasajes?o=${encodeURIComponent(p.origin)}&d=${encodeURIComponent(p.destination)}&f=${p.date_from}`;
const waShare = (p) => `https://wa.me/?text=${encodeURIComponent(`PROMO ${p.discount_pct}% OFF en Santiagueño: ${p.origin} → ${p.destination}, ${when(p).toLowerCase()}. Mirá las salidas: ${window.location.origin}${link(p)}`)}`;

const PromoCard = ({ p, i }) => {
  const n = daysLeft(p.date_to);
  return (
  <FadeUp delay={i * 0.06}>
    <div data-testid={`home-promo-${i}`} className="group relative flex h-full flex-col justify-between gap-6 rounded-3xl bg-white/[0.06] p-6 ring-1 ring-white/10 transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-white/[0.1]">
      <div className="flex items-start justify-between gap-3">
        <span title="Promoción" className="rounded-full bg-[var(--lime)] px-3 py-1 text-sm font-bold text-[var(--ink)]">PROMO {p.discount_pct}% OFF</span>
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/30 text-white transition-transform duration-300 group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
      </div>
      <div>
        <p data-testid={`home-promo-${i}-countdown`} className={`mb-3 inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${n <= 3 ? "bg-amber-300 text-[var(--ink)]" : "bg-white/10 text-white"}`}><Clock className="h-3.5 w-3.5" /> {countdown(n)}</p>
        <Link to={link(p)} data-testid={`home-promo-${i}-link`} className="block font-display text-3xl leading-tight text-white after:absolute after:inset-0 after:rounded-3xl after:content-['']">{p.origin}<span className="text-[var(--lime)]"> → </span>{p.destination}</Link>
        <p data-testid={`home-promo-${i}-dates`} className="mt-3 text-sm text-white/85">{when(p)} · {only(p)}</p>
        {p.max_seats ? <p className="mt-1 text-sm text-white/70">Cupo limitado: {p.max_seats} butacas por viaje</p> : null}
        <a href={waShare(p)} target="_blank" rel="noopener noreferrer" data-testid={`home-promo-${i}-share`}
          className="relative z-10 mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-bold text-[var(--ink)] transition-transform duration-200 hover:scale-105">
          <WhatsAppIcon className="h-4 w-4" /> Compartir por WhatsApp
        </a>
      </div>
    </div>
  </FadeUp>
  );
};

/** Promos de tramo vigentes. Si no hay ninguna, la sección no se muestra. */
export const PromosHome = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/fare-promos/active").then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => setList([])); }, []);
  if (!list.length) return null;
  return (
    <section data-testid="home-promos" className="bg-[var(--ink)] px-5 py-20 md:px-10 md:py-28">
      <div className="mx-auto max-w-7xl">
        <Eyebrow dark><Ticket className="h-4 w-4 text-[var(--lime)]" />Promos vigentes</Eyebrow>
        <h2 className="mt-5 font-display text-4xl text-white md:text-6xl"><MaskLines inView lines={["Viajá por menos,", "en estas fechas."]} /></h2>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => <PromoCard key={p.id} p={p} i={i} />)}
        </div>
      </div>
    </section>
  );
};
